import { getTextClassName } from '@nautilusbio/nb-design-system/helpers';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import type { AnyFieldApi } from '@tanstack/react-form';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

type UseTranslationParam = Parameters<typeof useTranslation>[0];

export function FieldInfo({
  field,
  showErrors,
  validatingNamespace,
}: {
  field: AnyFieldApi;
  showErrors?: boolean;
  validatingNamespace?: UseTranslationParam;
}) {
  const { t } = useTranslation(validatingNamespace ?? ('orgs' as UseTranslationParam));
  const shouldShow = showErrors !== undefined ? showErrors : field.state.meta.isTouched;

  return (
    shouldShow &&
    !field.state.meta.isValid && (
      <Stack
        alignItems="start"
        className={styles.errorContainer}
        gap={'pixel'}
        justifyContent="center"
        orientation="vertical"
      >
        {field?.state?.meta?.errors?.map((e, i) => (
          <Text as="strong" className={clsx(styles.error, getTextClassName('md'))} key={`error-${field.name}-${i}`}>
            {e?.message}
          </Text>
        ))}
        {field.state.meta.isValidating ? (
          <Text as="span" className={clsx(styles.validating)}>
            {t('validating')}&hellip;
          </Text>
        ) : null}
      </Stack>
    )
  );
}
